<template>
    <div>
        <slot name="activator" v-bind:on="onOpen"></slot>

        <b-modal ref="modal" title="แก้ไข" hide-footer>
            <div>
                <div v-if="previewPicture" class="d-flex justify-content-center align-items-center">
                    <a :href="previewPicture" target="_blank">
                        <b-img :src="previewPicture" width="200" height="200" thumbnail />
                    </a>
                </div>

                <b-form-group label="เปลี่ยนรูปภาพสินค้า" :description="uploading ? 'Uploading...' : null">
                    <b-form-file accept="image/*" v-model="file" :disabled="uploading"/>
                </b-form-group>

                <b-form-group label="ชื่อ">
                    <b-form-input type="text" :value="$props.product.description" readonly disabled/>
                </b-form-group>

                <b-form-group label="ราคา">
                    <b-form-input type="text" :value="$props.product.price" readonly disabled/>
                </b-form-group>

                <div class="d-flex justify-content-end">
                    <b-btn type="button" variant="outline-secondary" @click.prevent="$refs.modal.hide()">Cancel</b-btn>
                    <b-btn type="button" variant="success" class="ml-2" @click.prevent="onSave" :disabled="saving || uploading || !mediaUploaded">Save</b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            product: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            uploading: false,
            file: null,
            mediaUploaded: null,

            saving: false,
        }),

        computed: {
            previewPicture() {
                // If has new upload picture
                if (this.mediaUploaded && this.mediaUploaded.urls.original) {
                    return this.mediaUploaded.urls.original
                }

                // Display last product picture
                if (this.product.picture_url) {
                    return this.picture_url
                }

                return null
            }
        },

        watch: {
            file(file) {
                if (file) {
                    this.upload(file)
                } else {
                    this.reset()
                }
            }
        },

        methods: {
            onOpen() {
                this.reset()
                this.$refs.modal.show()
            },

            reset() {
                this.file = null
                this.mediaUploaded = null
            },

            async onSave() {
                this.saving = true

                try {
                    await axios.patch(`/products/${this.$props.product.id}`, {
                        action: 'change-picture',
                        media: this.mediaUploaded.id
                    })

                    window.location.reload()
                } catch (e) {
                    window.alert(e.message)
                }

                this.saving = false
            },

            async upload(file) {
                this.uploading = true

                try {
                    const form = new FormData()
                    form.append('file', file)

                    const { data } = await axios.post('/files', form)

                    this.mediaUploaded = data.data

                } catch (e) {
                    window.alert(e.message)
                }

                this.uploading = false
            }
        }
    }
</script>
